export const getfileIcon = (file: any, styles = {}) => {
  const hostPrefx = "/files/";
  let suffix = file.suffix?.toLowerCase();
  if (!suffix) {
    const match = file?.name?.match(/\.(\w*)/);
    if (match) {
      suffix = match[1];
      suffix = suffix?.toLowerCase();
    }
  }
  let name = "";
  if (!suffix) {
    name = "wenjianjia.png";
  } else {
    if (["png", "jpg", "gif", "jpeg"].indexOf(suffix) > -1) {
      name = "tupian.png";
    } else if (["doc", "docx"].indexOf(suffix) > -1) {
      name = "word.png";
    } else if (["xls", "xlsx"].indexOf(suffix) > -1) {
      name = "excel.png";
    } else if (["pdf"].indexOf(suffix) > -1) {
      name = "Pdf.png";
    } else if (["zip", "rar"].indexOf(suffix) > -1) {
      name = "rar.png";
    } else if (["ppt", "pptx"].indexOf(suffix) > -1) {
      name = "ppt.png";
    } else if (["txt"].indexOf(suffix) > -1) {
      name = "txt.png";
    }
  }
  return <img height={48} style={styles} src={`${hostPrefx}${name}`} />;
};
const FileLinks = (download: any, label: string) => {
  let pics;
  try {
    pics =
      download && Array.isArray(download) ? download : JSON.parse(download);
    pics = Array.isArray(pics) ? pics : [pics];
  } catch (e) {
    pics = null;
  }

  if (!pics) return null;
  return (
    <>
      {label && (
        <div
          style={{
            color: "black",
            fontWeight: 500,
            marginBottom: 10,
          }}
        >
          {label}:
        </div>
      )}
      {pics.map((item: any) => {
        if (item.name || item.title) {
          return (
            <>
              <div style={{ marginBottom: "10px" }}>
                {getfileIcon(item, {
                  width: "16px",
                  height: "16px",
                  marginRight: "8px",
                })}
                <a href={item.url || item.urls} target="blank">
                  {item.name || item.title}
                </a>
              </div>
            </>
          );
        }
        return null;
      })}
    </>
  );
};
export default FileLinks;
